import React, {useState, useEffect} from 'react';
import {Portals} from "./portals";

/***
 * 加载组件
 * @param {boolean} act  是否显示
 * @param {any} children
 * @return {*}
 * @constructor
 * @example <Loading>正在加载...</Loading>
 */
export const Loading = ({act,children='正在加载...'}) =>  <div className={"x-loading " + (act ? '' : 'hide')}>
    <div>
        <i/>
        <span>{children}</span>
    </div>
</div>;
